// extracted by mini-css-extract-plugin
module.exports = {"iconHolder":"UserList_iconHolder__3NMar","iconItem":"UserList_iconItem__2H0dP"};